var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangleCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7 Copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 27",
    width: 64,
    height: 64,
    rx: 4,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape 2 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31.3792C16 39.8729 22.8855 46.7584 31.3792 46.7584C39.869 46.749 46.749 39.869 46.7584 31.3792C46.7584 22.8855 39.8729 16 31.3792 16C22.8855 16 16 22.8855 16 31.3792ZM29.7217 34.1406L38.7681 25.8478C39.218 25.4351 39.854 25.2938 40.4363 25.4771C41.0187 25.6604 41.459 26.1405 41.5915 26.7365C41.7239 27.3325 41.5283 27.9539 41.0784 28.3666L30.8256 37.765C30.1511 38.3834 29.1093 38.3608 28.4623 37.7138L23.3359 32.5873C22.8917 32.1583 22.7135 31.523 22.8699 30.9255C23.0263 30.3281 23.4929 29.8615 24.0903 29.7051C24.6878 29.5487 25.3231 29.7269 25.7521 30.1711L29.7217 34.1406Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangleCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rectangleCheck.4572dd52bea7433b83ea643023a939d4.svg";